import { render, staticRenderFns } from "./IdleEnter.vue?vue&type=template&id=3bc1a0b6&scoped=true"
import script from "./IdleEnter.vue?vue&type=script&lang=js"
export * from "./IdleEnter.vue?vue&type=script&lang=js"
import style0 from "./IdleEnter.vue?vue&type=style&index=0&id=3bc1a0b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc1a0b6",
  null
  
)

export default component.exports